module.exports = __webpack_public_path__ + "img/cloud-shape.dd277248.svg";